import { Paper } from "@material-ui/core";
interface props {
  children: any;
  height?: number;
  border?: string;
  elevation?: number;
  variant?: "outlined" | "elevation";
}
const MainCard = ({ children, height, border, elevation, variant }: props) => {
  return (
    <Paper
      style={{
        width: "100%",
        padding: 20,
        height,
        border,
      }}
      elevation={elevation || 0}
      variant={variant}
    >
      {children}
    </Paper>
  );
};

export default MainCard;
